module.exports = __webpack_public_path__ + "img/pos_tolak.5f667a7c.png";